import { init } from './MallCPA16';
init();
